import { Route } from "@angular/router"
import { BranchListComponent } from "./ui/branch-list/branch-list.component"

const branchRoutes: Route[] = [
    {
      path: '',
      children: [
        {
          path: 'branches',
          component: BranchListComponent
        }
      ]
    }
  ]
  
  export default branchRoutes